import React, { ReactElement, FunctionComponent, isValidElement } from 'react';

type CtaBoxActionsProps = {
    children: ReactElement | ReactElement[];
    qaRole?: string;
};

const CtaBoxActions: FunctionComponent<CtaBoxActionsProps> = ({ children, qaRole }) => {
    // todo: check the children validation
    if (!isValidElement(children)) {
        return null;
    }

    return (
        <div className="cta-box__actions" data-qa-role={qaRole || 'cta-box-actions'}>
            {children}
        </div>
    );
};

export default CtaBoxActions;
